import React, { Component } from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import Link from '@material-ui/core/Link';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import FileIcon from '@material-ui/icons/InsertDriveFile';
import { connect } from 'react-redux';
import { solidLogin, setHost, enterFolder, solidLogout, clearCache, MyDispatch, setErrorMessage, closeDialog } from '../../../Actions/Actions';
import { getLocationObjectFromUrl } from '../../HistoryHandler/HistoryHandler';
import { DialogButtonClickEvent, DialogDispatchProps, DialogStateProps } from '../dialogTypes';
import { AppState } from '../../../Reducers/reducer';
import { DIALOGS } from '../../../Actions/actionTypes';

class FormDialog extends Component<ChooseLocationProps> {
    state = {
        location: '',
    };

    componentWillReceiveProps(props: ChooseLocationProps) {
        const { isLoggedIn, webId } = props;
        const params = new URLSearchParams(document.location.search.substr(1));
        const encodedUrl = params.get('url');

        if (encodedUrl !== null) {
            const location = decodeURI(encodedUrl);
            this.setState({ location });
        }
        else if (isLoggedIn && webId) {
            const location = (new URL(webId)).origin;
            this.setState({ location });
        }
    }

    handleChange(event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) {
        const targetForm = event.currentTarget.form;
        if (targetForm) {
            const input = targetForm.querySelector('input');
            if (input) {
                const location = input.value;
                this.setState({ location });
                return;
            }
        }
        console.log("Couldn't find location input");
    }

    handleAdvanceOption(event: DialogButtonClickEvent){
        const divAdvanceOption = document.getElementById("divAdvanceOption");
        if(divAdvanceOption != null)
        {
            let icon = '';
            if (divAdvanceOption.classList.contains("hidden")){
                divAdvanceOption.classList.remove("hidden");
                icon = '&#9652;'
            }
            else{
                divAdvanceOption.classList.add("hidden");
                icon = '&#9662;'
            }
            var buttonAdvance = document.getElementById("btnAdvanceOption");
            if(buttonAdvance != null){
                buttonAdvance.innerHTML = "Advance option" + icon;
            }
        }
    }

    handleSubmit(event: DialogButtonClickEvent) {
        this.props.handleSubmit(event, { location: this.state.location });
    }

    render() {
        let { location } = this.state;
        location = location ? location : '';
        const { handleClose, handleLogin, handleLogout, open, isLoggedIn, webId } = this.props;

        return (
            <Dialog open={open} onClose={handleClose} aria-labelledby="form-dialog-choose-location" fullWidth={true} maxWidth={'sm'}>
                <form>
                    <DialogTitle id="form-dialog-choose-location">Welcome to SolidRDP</DialogTitle>
                    <DialogContent>
                        <Typography variant="body1" gutterBottom className="fs14">
                            {!isLoggedIn ?
                                "Where is your research data located?"
                                : 
                                [
                                    <span key="spanLoginAs">Logged in as {webId}.</span>,
                                    <Button key="btnLogout" size="small" variant="text" color="secondary" onClick={handleLogout}>[Logout]</Button>
                                ]
                            }
                        </Typography>
                        {!isLoggedIn ?
                            [
                                <Button key="btnOpen" variant="raised" size="large" color="secondary" fullWidth={true} onClick={handleLogin}>Open my Research POD</Button>,
                                <Typography key="txtLearn" variant="body1" gutterBottom align="left" className="smallNote">
                                    *If you do not have a research POD yet, learn <Link href="https://solid.inrupt.com/get-a-solid-pod">How to create a new one?</Link>
                                </Typography>
                            ]
                            : ''
                        }
                        {!isLoggedIn ? '' :
                            [
                                <Button id="btnAdvanceOption" key="btnAdvanceOption" variant="text" onClick={this.handleAdvanceOption} className="advanceOption">Advance option&#9662;</Button>,
                                <div id="divAdvanceOption" className="hidden" key="divAdvanceOption">
                                    <Typography key="lblStoreLocation" variant="body1" className="fs14">
                                        Change your research data directory:
                                    </Typography>
                                    <TextField key="txtStoreLocation" autoFocus fullWidth
                                        margin="normal"
                                        variant="standard"
                                        className="fs14 mt8"
                                        onChange={this.handleChange.bind(this)}
                                        value={location} />
                                </div>
                            ]
                        }
                    </DialogContent>
                    <DialogActions>

                        {!isLoggedIn ?
                            <Button onClick={handleClose} color="primary" type="button">
                                Close
                            </Button>
                            :
                            <Button variant="raised" size="large" color="secondary" type="submit" onClick={this.handleSubmit.bind(this)}>
                                Continue
                            </Button>
                        }
                    </DialogActions>
                </form>
            </Dialog>
        );
    }
}

interface StateProps extends DialogStateProps {
    webId: string | null;
    isLoggedIn: boolean;
}
interface DispatchProps extends DialogDispatchProps {
    handleLogin(event: DialogButtonClickEvent): void;
    handleLogout(event: DialogButtonClickEvent): void;
    handleSubmit(event: DialogButtonClickEvent, { location }: { location: string }): void;
}
interface ChooseLocationProps extends StateProps, DispatchProps { }


const mapStateToProps = (state: AppState): StateProps => {
    return {
        open: state.visibleDialogs.CHOOSE_LOCATION,
        webId: state.account.webId,
        isLoggedIn: state.account.loggedIn
    };
};

const mapDispatchToProps = (dispatch: MyDispatch): DispatchProps => {
    return {
        handleClose: () => {
            dispatch(closeDialog(DIALOGS.CHOOSE_LOCATION));
        },
        handleLogin: event => {
            event.preventDefault();
            dispatch(solidLogin());
        },
        handleLogout: event => {
            event.preventDefault();
            dispatch(solidLogout());
        },
        
        handleSubmit: (event, { location }) => {
            event.preventDefault();
            if (!location)
                return dispatch(setErrorMessage("Please enter the folder which should be opened"));

            const { host, path } = getLocationObjectFromUrl(location);
            dispatch(closeDialog(DIALOGS.CHOOSE_LOCATION));
            dispatch(setHost(host));
            dispatch(clearCache());
            dispatch(enterFolder(path));
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(FormDialog);
